var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgG2Logo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    display: "block"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 60c16.569 0 30-13.431 30-30C60 13.431 46.569 0 30 0 13.431 0 0 13.431 0 30c0 16.569 13.431 30 30 30z",
    fill: "var(--fill-0, #FF492C)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.984 22.98H37.86c.138-.805.636-1.255 1.644-1.765l.942-.48c1.686-.864 2.586-1.842 2.586-3.438 0-1.002-.39-1.794-1.164-2.364-.774-.57-1.686-.852-2.754-.852a4.247 4.247 0 00-2.334.666c-.702.432-1.224.99-1.548 1.686l1.482 1.488c.576-1.164 1.41-1.734 2.508-1.734.93 0 1.5.48 1.5 1.146 0 .558-.276 1.02-1.344 1.56l-.606.294c-1.314.666-2.226 1.428-2.754 2.292-.528.864-.786 1.95-.786 3.264v.36h7.752V22.98zM42.3 27.552h-8.485l-4.242 7.344h8.484l4.242 7.35 4.242-7.35-4.242-7.344z",
    fill: "var(--fill-0, white)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.306 39.798c-5.4 0-9.798-4.398-9.798-9.798s4.398-9.798 9.798-9.798l3.354-7.014a17.176 17.176 0 00-3.354-.33c-9.468 0-17.142 7.674-17.142 17.142s7.674 17.142 17.142 17.142a17.034 17.034 0 0010.092-3.288l-3.708-6.432a9.768 9.768 0 01-6.384 2.376z",
    fill: "var(--fill-0, white)"
  })));
}
export default SvgG2Logo;